'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _reduxActions = require('redux-actions');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var _ActionTypes = require('../constants/ActionTypes');

var _VisitorIdentity = require('../records/VisitorIdentity');

var _VisitorIdentity2 = _interopRequireDefault(_VisitorIdentity);

var _setMessagesUtk = require('../operators/setMessagesUtk');

var _setHubspotUtk = require('../operators/setHubspotUtk');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var visitorIdentity = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _VisitorActionTypes.RECEIVED_WIDGET_SHELL_DATA, function (state, action) {
  var messagesUtk = action.payload.messagesUtk;

  return (0, _setMessagesUtk.setMessagesUtk)(messagesUtk, state);
}), _defineProperty(_handleActions, _ActionTypes.UPDATE_HUBSPOT_UTK, function (state, action) {
  var hubspotUtk = action.payload.hubspotUtk;

  return (0, _setHubspotUtk.setHubspotUtk)(hubspotUtk, state);
}), _handleActions), new _VisitorIdentity2.default());

exports.default = visitorIdentity;
module.exports = exports['default'];